module.exports = __webpack_public_path__ + "img/D201901_1.36ac277c.jpg";